<template>
    <div>
        <div class="sitemap" ref="d3_root"></div>
        <div v-if="chartData && (!render_info || render_info.display_extra)">
            <span style="color:lightgray">
                Sitemap
            </span>
        </div>
    </div>
</template>

<script>
    import * as d3 from "d3";
    export default {
        data() {
            return {
                test: [],
            }
        },
        mounted() {
            if (this.chartData) {
                this.draw()
            }
        },
        computed: {
            cleanedChartData: function() {
                if (this.chartData && this.chartData.children) {
                    let newParents = this.chartData.children.map(parent => {
                        if (parent.children) {
                            let newChildren = parent.children.map(child => {
                                if (child.children) {
                                    let newGrandChildren = child.children.map(grandchild => {
                                        if (grandchild.field_value === 'NO VALUE') {
                                            return false
                                        } else {
                                            return grandchild
                                        }
                                    })
                                    child.children = newGrandChildren.filter(grandchild => {
                                        return grandchild
                                    })
                                }
                                return child
                            })
                            parent.children = newChildren
                        }
                        return parent
                    })
                    this.chartData. parents = newParents
                    return d3.hierarchy(this.chartData)
                }
            },
        },
        watch: {
            highlighted: function (newValue,oldValue) {
              if (newValue !== oldValue) this.draw()
            },
            chartData: function (newValue) {
                if (newValue) this.draw()
            },
            height: function(newValue) {
                if (newValue) this.draw()
            },
            text_size: function(newValue) {
                if (newValue) this.draw()
            },
            hover_category: function(newValue) {
                this.draw()
            }
        },
        props: ['height','width', 'text_size', 'chartData','highlighted','render_info'],
        methods: {
            draw() {
                function commarize(number) {
                    let min = 1e3;
                    // Alter numbers larger than 1k
                    if (number >= min) {
                        var units = ["k", "M", "B", "T", "Q"];

                        var order = Math.floor(Math.log(number) / Math.log(1000));

                        var unitname = units[(order - 1)];
                        var num = Math.floor(number / 1000 ** order);

                        // output number remainder + unitname
                        return num + unitname
                    }

                    // return formatted original number
                    return number.toLocaleString()
                }

                const svg_element = document.createElementNS("http://www.w3.org/2000/svg",'svg')

                let margin_between = 10

                const svg = d3.select(svg_element)
                    .attr("viewBox", `0 0 ${this.width} ${this.height}`)
                ;
                svg.append('g')
                    .attr('id','rectangles')

                svg.append('g')
                    .attr('id','clip-paths')

                svg.append('g')
                    .attr('id','lines')

                svg.append('g')
                    .attr('id','labels')

                while (this.$refs.d3_root.firstChild) {
                    this.$refs.d3_root.removeChild(this.$refs.d3_root.firstChild);
                }

                let parents = this.cleanedChartData.children
                console.log(parents)

                // The root, parent, and children are one unit each
                // The grandchildren are half a unit each
                let units = 0
                let max_units = 0
                let sequence = 0
                let parents_with_units = parents.map(parent => {
                    sequence++
                    units = 2 // one for the root node, one for the parent
                    console.log('parent')
                    console.log(parent)
                    if (parent.children) {
                        parent.children.forEach(child => {
                            units += 1
                            if (child.children) {
                                child.children.forEach(grandchild => {
                                    units += 0.5
                                })
                            }
                        })
                    }
                    if (units > max_units) {
                        max_units = units
                    }
                    parent.units = units
                    return parent
                })

                let rectangles_across = parents_with_units.length
                console.log('count of rectangles horizontally')
                console.log(rectangles_across)

                let rectangles_g = svg.select("#rectangles")
                let clip_path_g = svg.select("#clip-paths")
                let lines_g = svg.select("#lines")
                let labels_g = svg.select("#labels")

                let rectangle_container_width = this.width / rectangles_across

                let unit_container_height = Math.floor(this.height / max_units)

                /*

                    Each rectangle, including margins and padding, fits within unit_container_height

                    vertical +->  +---------------+   <---+
                    margin   |    |               |       |
                             +->  |    +-----+    |       |
                                  |    |*****|    |       | unit_container_height
                                  |    +-----+    |       |
                                  |               |       |
                                  +---------------+   <---+

                                  ^    ^
                                  |    |
                                  +--------- horizontal_margin

                 */

                let horizontal_margin = 5
                let vertical_margin = 5
                let grandchild_indent = 10

                let rectangle_width = rectangle_container_width - horizontal_margin * 2

                // ROOT
                rectangles_g.append('rect')
                    .attr('x',0+horizontal_margin)
                    .attr('y',0+vertical_margin)
                    .attr('width',rectangle_width)
                    .attr('height',unit_container_height-vertical_margin*2)
                    .attr('fill','#eeeeee')
                    .attr('stroke','black')
                let root_connector_start = unit_container_height - vertical_margin
                let root_connector_middle_start = unit_container_height - vertical_margin / 4
                let root_connector_end = unit_container_height + vertical_margin
                lines_g.append('line')
                    .attr('x1', rectangle_container_width / 2)
                    .attr('y1', root_connector_middle_start)
                    .attr('x2', rectangles_across * rectangle_container_width - rectangle_container_width / 2) // all the way to the right
                    .attr('y2',root_connector_middle_start)
                    .attr('stroke','gray')

                // PARENTS
                let column_position = 0
                let is_first_parent = true
                parents_with_units.forEach(parent => {
                    sequence++
                    console.log('parent')
                    console.log(parent)
                    // move down the height of the root + the vertical margin.
                    // this is the position we'll start drawing the box.
                    let unit_position = unit_container_height+vertical_margin
                    let rectangle_fill = '#eeeeee'
                    let rectangle_stroke = 'black'
                    if (parent.data.field_value === "OTHER") {
                        rectangle_fill = 'white'
                        rectangle_stroke = 'black'
                    }
                    let x = rectangle_container_width * column_position + horizontal_margin
                    let rectangle_height = unit_container_height-vertical_margin*2
                    let label_padding = 5
                    console.log('max units = ' + max_units)
                    if (max_units > 15) {
                        label_padding = 1
                    }
                    rectangles_g.append('rect')
                        .attr('x',x)
                        .attr('y',unit_position)
                        .attr('width',rectangle_width)
                        .attr('height', rectangle_height)
                        .attr('fill',rectangle_fill)
                        .attr('stroke',rectangle_stroke)
                        .attr('stroke-width',2)
                        .data([parent])
                        .on('click',d => {
                            let node = d
                            let args = []
                            while (node.depth>=1) {
                                let raw_type = node.data.type
                                let massaged_type = raw_type
                                if (raw_type==='group_by') {
                                    massaged_type = 'group_value'
                                } else if (raw_type==='primary_field') {
                                    massaged_type = 'label'
                                } else {
                                    massaged_type = 'color'
                                }
                                args[massaged_type] = node.data.field_value
                                node = node.parent
                            }
                            this.$emit('stackChartClicked', args);
                        })
                    let clip_id = 'clip-' + sequence
                    clip_path_g.append("clipPath")       // define a clip path
                        .attr("id", clip_id) // give the clipPath an ID
                        .append("rect")          // shape it as a rectangle
                        .attr("x", x)
                        .attr("y", unit_position)
                        .attr("width", rectangle_width)
                        .attr("height", rectangle_height);
                    let main_font_height = (rectangle_height - label_padding) * 2 / 3
                    if (main_font_height > 15) {
                        main_font_height = 15
                    }
                    let secondary_font_height = 0
                    if (main_font_height > 11) {
                        secondary_font_height = (rectangle_height - label_padding) / 3
                    } else {
                        main_font_height = rectangle_height - label_padding
                    }
                    labels_g.append('text')
                        .attr('x',rectangle_container_width * column_position + rectangle_container_width / 2)
                        .attr('y',unit_position + rectangle_height / 2 - secondary_font_height + label_padding)
                        .attr('font-size', main_font_height + 'px')
                        .attr('dominant-baseline','middle')
                        .attr('text-anchor','middle')
                        .text(parent.data.field_value)
                        .attr("clip-path", "url(#" + clip_id + ")")
                    if (secondary_font_height) {
                        labels_g.append('text')
                            .attr('x',rectangle_container_width * column_position + rectangle_container_width / 2)
                            .attr('y',unit_position + rectangle_height / 2 + secondary_font_height)
                            .attr('font-size', secondary_font_height + 'px')
                            .attr('dominant-baseline','middle')
                            .attr('text-anchor','middle')
                            .text(' (' + parent.data.aggregate_count + ')')
                            .attr("clip-path", "url(#" + clip_id + ")")
                    }
                    // unit_position at the end should be at the end of the container in which
                    // we drew this rectangle
                    unit_position += rectangle_height + vertical_margin
                    let this_connector_start = root_connector_middle_start
                    if (is_first_parent) {
                        this_connector_start = root_connector_start
                        is_first_parent = false
                    }
                    let midpoint = rectangle_container_width * column_position + rectangle_container_width / 2
                    lines_g.append('line')
                        .attr('x1', midpoint)
                        .attr('y1', this_connector_start)
                        .attr('x2', midpoint)
                        .attr('y2',root_connector_end)
                        .attr('stroke','gray')

                    let parent_connector_start = unit_position - vertical_margin
                    // by the end of drawing the parent, unit_position is at the edge of the containing box
                    let is_first_child = true
                    parent.children.forEach(child => {
                        sequence++
                        console.log('child')
                        console.log(child)
                        console.log('unit_position at start of child loop (before adding margin): ' + unit_position)
                        // move unit_position to where we're going to start drawing the rectangle for the child
                        unit_position += vertical_margin
                        console.log('unit_position right before drawing a child (after adding margin): ' + unit_position)
                        let connector_end = unit_position
                        let connector_start = unit_position - vertical_margin
                        if (is_first_child) {
                            is_first_child = false
                            connector_start = parent_connector_start
                        }

                        lines_g.append('line')
                            .attr('x1', midpoint)
                            .attr('y1', connector_start)
                            .attr('x2', midpoint)
                            .attr('y2',connector_end)
                            .attr('stroke','blue')

                        rectangle_fill = '#eeeeee'
                        rectangle_stroke = 'black'
                        if (child.data.field_value === "OTHER") {
                            rectangle_fill = 'white'
                            rectangle_stroke = '#cccccc'
                        }
                        rectangles_g.append('rect')
                            .attr('x',rectangle_container_width * column_position + horizontal_margin)
                            .attr('y',unit_position)
                            .attr('width',rectangle_width)
                            .attr('height',unit_container_height-vertical_margin * 2)
                            .attr('fill',rectangle_fill)
                            .attr('stroke',rectangle_stroke)
                            .data([child])
                            .on('click',d => {
                                let node = d
                                let args = []
                                while (node.depth>=1) {
                                    let raw_type = node.data.type
                                    let massaged_type = raw_type
                                    if (raw_type==='group_by') {
                                        massaged_type = 'group_value'
                                    } else if (raw_type==='primary_field') {
                                        massaged_type = 'label'
                                    } else {
                                        massaged_type = 'color'
                                    }
                                    args[massaged_type] = node.data.field_value
                                    node = node.parent
                                }
                                this.$emit('stackChartClicked', args);
                            })

                        labels_g.append('text')
                            .attr('x',rectangle_container_width * column_position + rectangle_container_width / 2)
                            .attr('y',unit_position + unit_container_height / 4)
                            .attr('font-size','smaller')
                            .attr('dominant-baseline','middle')
                            .attr('text-anchor','middle')
                            .text(child.data.field_value + ' (' + child.data.aggregate_count + ')')
                        // unit_position is at the bottom of the *rectangle* we drew but not the container
                        // (that happens after drawing any grandchildren)
                        unit_position += unit_container_height
                        console.log('unit_position right before starting to draw grandchildren: ' + unit_position)

                        if (child.children) {
                            // also draw the vertical line to connect all the grandchildren
                            /*
                            lines_g.append('line')
                                .attr('x1', rectangle_container_width * column_position + horizontal_margin)
                                .attr('y1', unit_position)
                                .attr('x2', rectangle_container_width * column_position + horizontal_margin)
                                .attr('y2',child.children.length * unit_container_height / 2 - vertical_margin / 4)
                                .attr('stroke','blue')

                             */

                            // let is_first_grandchild = true
                            child.children.forEach(grandchild => {
                                unit_position += vertical_margin/2
                                console.log('---unit_position right before starting to draw a grandchild: ' + unit_position)

                                let grandchild_height = unit_container_height / 2 - vertical_margin / 2
                                let label = grandchild.data.field_value + ' (' + grandchild.data.aggregate_count + ')'
                                let label_color = 'black'
                                if (grandchild.data.field_value === "OTHER") {
                                    label_color = 'gray'
                                    let r = unit_container_height / 8
                                    let distance_between_ellipses = r * 3
                                    let circle_color = '#eeeeee'
                                    rectangles_g.append('circle')
                                        .attr('cx',rectangle_container_width * column_position + rectangle_container_width / 2)
                                        .attr('cy',unit_position + unit_container_height / 4)
                                        .attr('r',r)
                                        .attr('fill',circle_color)
                                    rectangles_g.append('circle')
                                        .attr('cx',rectangle_container_width * column_position + rectangle_container_width / 2 - distance_between_ellipses)
                                        .attr('cy',unit_position + unit_container_height / 4 )
                                        .attr('r',r)
                                        .attr('fill',circle_color)
                                    rectangles_g.append('circle')
                                        .attr('cx',rectangle_container_width * column_position + rectangle_container_width / 2 + distance_between_ellipses)
                                        .attr('cy',unit_position + unit_container_height / 4 )
                                        .attr('r',r)
                                        .attr('fill',circle_color)
                                } else {
                                    rectangles_g.append('rect')
                                        .attr('x',grandchild_indent + rectangle_container_width * column_position + horizontal_margin)
                                        .attr('y',unit_position)
                                        .attr('width',rectangle_width - grandchild_indent)
                                        .attr('height',grandchild_height)
                                        .attr('fill','#eeeeee')
                                        .data([grandchild])
                                        .on('click',d => {
                                            let node = d
                                            let args = []
                                            while (node.depth>=1) {
                                                let raw_type = node.data.type
                                                let massaged_type = raw_type
                                                if (raw_type==='group_by') {
                                                    massaged_type = 'group_value'
                                                } else if (raw_type==='primary_field') {
                                                    massaged_type = 'label'
                                                } else {
                                                    massaged_type = 'color'
                                                }
                                                args[massaged_type] = node.data.field_value
                                                node = node.parent
                                            }
                                            this.$emit('stackChartClicked', args);
                                        })
                                }
                                labels_g.append('text')
                                    .attr('x',rectangle_container_width * column_position + rectangle_container_width / 2)
                                    .attr('y',unit_position + unit_container_height / 4)
                                    .attr('font-size','x-small')
                                    .attr('dominant-baseline','middle')
                                    .attr('text-anchor','middle')
                                    .attr('fill',label_color)
                                    .text(label)
                                unit_position += grandchild_height + vertical_margin / 2
                                console.log('---unit_position right after drawing a grandchild: ' + unit_position)

                            })
                        } else {
                            console.log('no grandchildren')
                        }

                        unit_position += vertical_margin
                        console.log('unit_position right after drawing a child: ' + unit_position)
                    })
                    column_position++
                })

                console.log('about to append the entire svg')
                console.log(svg.node())
                this.$refs.d3_root.append(svg.node())

            },
            removeElement(elementId) {
                // Removes an element from the document
                var element = document.getElementById(elementId);
                element.parentNode.removeChild(element);
            }
        }
    }
</script>